export const REPOSITORY_URL = "https://github.com/alachhman/Emblem-API";